// extracted by mini-css-extract-plugin
export var dropdown = "_vq-0";
export var imageWrapper = "_vq-3";
export var itemNameContainer = "_vq-1";
export var productImage = "_vq-2";
export var spinnerWrapper = "_vq-4";